var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "nominee-category" }, [
    _c("div", [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "mb-0 col mb-sm-2 simple-dropdown-wrapper" },
          [
            _c("p", { staticClass: "bodytext mb-1" }, [
              _vm._v(_vm._s(_vm.trans("lifechallenge_category")))
            ]),
            _c("nominee-simple-dropdown", {
              attrs: { dataSource: _vm.categoriesData, displayProp: "title" },
              model: {
                value: _vm.category,
                callback: function($$v) {
                  _vm.category = $$v
                },
                expression: "category"
              }
            })
          ],
          1
        )
      ]),
      _c(
        "div",
        { staticClass: "lc-project-list row" },
        _vm._l(_vm.nomineeSelectedItems, function(project) {
          return _c("nominee-project", { attrs: { project: project } })
        }),
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }